import React from "react";
import { Link } from "react-router-dom";
import variation1 from "../../Assets/variation1.webp";
import variation2 from "../../Assets/variation2.webp";
import variation3 from "../../Assets/variation3.webp";
import variation4 from "../../Assets/variation4.webp";
import variation5 from "../../Assets/variation5.webp";
import "./YogaVariations.css";

// `to` is the page the button under the chart opens (/asanas/<slug>)
const VARIATIONS = [
  {
    src: variation1,
    alt: "14 variations of Hanumanasana",
    to: "/asanas/hanumanasana",
    cta: "Explore Hanumanasana",
  },
  {
    src: variation2,
    alt: "11 variations of Camel Pose or Ushtrasana",
    to: "/asanas/ushtrasana",
    cta: "Explore Ushtrasana",
  },
  {
    src: variation3,
    alt: "14 variations of Vasishtasana or Side Plank Pose",
    to: "/asanas/vasishtasana",
    cta: "Explore Vasishtasana",
  },
  {
    src: variation4,
    alt: "9 variations of Sarvangasana or Shoulderstand",
    to: "/asanas/sarvangasana",
    cta: "Explore Sarvangasana",
  },
  {
    src: variation5,
    alt: "18 variations of Malasana or Garland Pose",
    to: "/asanas/malasana",
    cta: "Explore Malasana",
  },
];

const YogaVariations = () => (
  <section className="yoga-variations" aria-labelledby="yoga-variations-title">
    <h2 id="yoga-variations-title">Yoga Variations</h2>

    <div className="yoga-variations-grid">
      {VARIATIONS.map((v) => (
        <figure className="yoga-variation-card" key={v.alt}>
          <img src={v.src} alt={v.alt} loading="lazy" />
          <Link className="yoga-variation-link" to={v.to}>
            {v.cta}
          </Link>
        </figure>
      ))}
    </div>
  </section>
);

export default YogaVariations;
